import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Modal } from 'antd';
import axiosRestaurantInstance from './AxiosRestaurantInstance';
import './css/Profile.css';

const Profile = () => {
  const user = JSON.parse(localStorage.getItem('user')); 
  const userId = user.userId; // Extract userId
  const [userData, setUserData] = useState(null);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axiosRestaurantInstance.get(`/user/${userId}`);
        setUserData(response.data.user);
      } catch (error) {
        console.error('Error fetching user data:', error);
        message.error('Failed to fetch user data.');
      }
    };

    if (userId) fetchUser();
  }, [userId]);

  const showPasswordModal = () => {
    setIsPasswordModalOpen(true);
  };

  const showEditProfileModal = () => {
    setIsEditModalOpen(true);
    editForm.setFieldsValue(userData); // Pre-fill form with current user data
  };

  const handlePasswordChange = async (values) => {
    setLoading(true); // Show loading spinner
    try {
        console.log("Verifying old password...");

        // Step 1: Verify old password
        const verifyResponse = await axiosRestaurantInstance.post(`/verify-password/${userId}`, {
            password: values.oldPassword, // Send old password
        });

        console.log("Verify response:", verifyResponse);

        if (verifyResponse.status === 200) {
            // Old password verified successfully
            console.log("Old password verified. Proceeding to update new password...");

            // Step 2: Update new password
            const updateResponse = await axiosRestaurantInstance.put(`/update-user/${userId}`, {
                password: values.password, // Send new password
            });

            console.log("Update response:", updateResponse);

            if (updateResponse.status === 200) {
                message.success('Password updated successfully');
                setIsPasswordModalOpen(false); // Close modal
                form.resetFields(); // Clear form fields
            } else {
                // Update response did not return success
                message.error('Failed to update password. Please try again.');
            }
        } else {
            // Old password is incorrect
            message.error('Old password is incorrect.');
        }
    } catch (error) {
        // Handle errors from API
        console.error('Error during password change:', error.response?.data || error.message);
        const errorMessage = error.response?.data?.error || 'Failed to update password.';
        message.error(errorMessage);
    } finally {
        setLoading(false); // Hide loading spinner
    }
};


  const handleProfileEdit = async (values) => {
    setLoading(true);
    try {
      const response = await axiosRestaurantInstance.put(`/update-user/${userId}`, values);

      if (response.status === 200) {
        message.success('Profile updated successfully');
        setUserData(values); // Update the local state with new data
        setIsEditModalOpen(false);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      message.error('Failed to update profile.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-container">
      <Card title="User Profile" className="profile-card">
        {userData ? (
          <div className="profile-details">
            <p><strong>First Name:</strong> {userData.firstName}</p>
            <p><strong>Last Name:</strong> {userData.lastName}</p>
            <p><strong>Email:</strong> {userData.email}</p>
            <p><strong>Mobile:</strong> {userData.mobile}</p>
            <p><strong>Roles:</strong> {userData.roles ? userData.roles.join(', ') : 'No roles assigned'}</p>
            <Button onClick={showPasswordModal} style={{ marginRight: '10px' }}>
              Change Password
            </Button>
            <Button onClick={showEditProfileModal}>Edit Profile</Button>
          </div>
        ) : (
          <p>Loading...</p>
        )}

        {/* Change Password Modal */}
        <Modal
          title="Change Password"
          open={isPasswordModalOpen}  // Updated from `visible` to `open`
          onCancel={() => setIsPasswordModalOpen(false)}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={handlePasswordChange}>
            <Form.Item
              name="oldPassword"
              label="Old Password"
              rules={[
                { required: true, message: 'Please enter your old password' },
              ]}
            >
              <Input.Password placeholder="Enter old password" />
            </Form.Item>
            <Form.Item
              name="password"
              label="New Password"
              rules={[
                { required: true, message: 'Please enter a new password' },
              
              ]}
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Update Password
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        {/* Edit Profile Modal */}
        <Modal
          title="Edit Profile"
          open={isEditModalOpen}  // Updated from `visible` to `open`
          onCancel={() => setIsEditModalOpen(false)}
          footer={null}
        >
          <Form form={editForm} layout="vertical" onFinish={handleProfileEdit}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: 'Please enter your first name' }]}
            >
              <Input placeholder="Enter first name" />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: 'Please enter your last name' }]}
            >
              <Input placeholder="Enter last name" />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
            <Form.Item
              name="mobile"
              label="Mobile"
              rules={[{ required: true, message: 'Please enter your mobile number' }]}
            >
              <Input placeholder="Enter mobile number" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save Changes
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </Card>
    </div>
  );
};

export default Profile;
